import { Box, Paper, Typography } from "@mui/material";
import GlobalMarketProductPriceChartForm from "./GlobalMarketProductPriceChartForm";
import GlobalMarketProductPriceChartChart from "./GlobalMarketProductPriceChartChart";
import ShowFavoritesButton from "../../../components/favorite/ShowFavoritesButton";
import Favorites from "../../../components/favorite/Favorites";
import { useGlobalMarketProductPriceChartContext } from "../../../context/global-market/GlobalMarketProductPriceChartContext";
import { deleteData } from "../../../lib/dashboard/actions";
import { mutate } from "swr";
import GlobalMarketProductPriceChartFavoriteCard from "./GlobalMarketProductPriceChartFavoriteCard";
const GlobalMarketProductPriceChart = () => {
  const {
    favorites,
    isFavoritesModal,
    setIsFavoritesModal,
    setSelected,
    handleShowChart,
    isLoadingChart,
  } = useGlobalMarketProductPriceChartContext();

  const handleSelectedFavorite = async (favorite) => {
    const {
      industry,
      industry_name,
      commodity,
      commodity_name,
      commodity_type,
      commodity_type_name,
      transit,
      transit_name,
    } = favorite;
    await setSelected((prev) => ({
      ...prev,
      industry: { id: industry, name: industry_name },
      commodityType: { id: commodity_type, name: commodity_type_name },
      commodity: commodity && { id: commodity, name: commodity_name },
      transitType: transit && { id: transit, name: transit_name },
    }));

    const body = {
      industry_id: industry,
      commodity_type_id: commodity_type,
      commodity_id: commodity,
      transit_id: transit,
    };

    await handleShowChart(body);
    setIsFavoritesModal(false);
  };

  const handleDeleteFavorite = async (id, e) => {
    e.stopPropagation();
    const { status } = await deleteData(
      `/favorite/global-favorite-price-chart/${id}`
    );
    if (status === 200) await mutate("/favorite/global-favorite-price-chart");
  };

  return (
    <Paper
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "20px",
      }}
    >
      {/* header  */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Typography sx={{ fontSize: "16px", fontWeight: 700 }}>
          نمودار قیمتی کالا
        </Typography>
        <ShowFavoritesButton onClick={() => setIsFavoritesModal(true)} />
      </Box>
      <Favorites
        isChartLoading={isLoadingChart}
        isOpen={isFavoritesModal}
        handleClose={() => setIsFavoritesModal(false)}
        favorites={favorites}
        handleSelectedFavorite={handleSelectedFavorite}
        handleDeleteFavorite={handleDeleteFavorite}
        FavoriteCard={GlobalMarketProductPriceChartFavoriteCard}
      />
      {/* form */}
      <GlobalMarketProductPriceChartForm />

      {/* chart  */}
      <GlobalMarketProductPriceChartChart />
    </Paper>
  );
};

export default GlobalMarketProductPriceChart;
